import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"word-break":"keep-all","overflow-wrap":"break-word"} }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("wbr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (d) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: d }, [
        _createElementVNode("span", { innerHTML: d }, null, 8, _hoisted_2),
        _hoisted_3
      ], 64))
    }), 128))
  ]))
}